import travelRequest from "./travelRequest.component";
import travelRequestUrls from "./travelRequest.urls";
import TravelRequestTransforms from "./travelRequest.transforms";

const travelRequestModule = angular
  .module("app.components.travelRequest", [])
  .component("travelRequestPage", travelRequest)
  .service("TravelRequestTransforms", TravelRequestTransforms)
  .config(travelRequestUrls);

export default travelRequestModule;



// WEBPACK FOOTER //
// ./src/pages/travelRequest/travelRequest.module.js